import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Projects from './pages/Projects';
import './App.css';
import Reviews from './pages/Reviews';
import Faqs from './pages/Faqs';
import Pricing from './pages/Pricing';
import Booking from './pages/Booking';

const App = () => (
  <Router>
    <Header />
    <main className="content">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path='/about' element={<Projects/>}/>
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/faqs" element={<Faqs/>}/>
        <Route path= '/booking/:id' element ={<Booking/>}/>

      </Routes>
    </main>
    <Footer />
  </Router>
);

export default App;